import { IaAudience, iaAudience } from '~/composables/unified/useIaAudience';
import { serverFlagAnswer } from '~/utils/featureFlags/serverFlagAnswer';

/**
 * /explore serves two releases: the new information architecture's Explore and the institution
 * guide's index. It stays open while either one is out for the visitor; with neither, they go home.
 */
export default defineNuxtRouteMiddleware(async () => {
  // The Nuxt context is lost after the await, so it is re-bound for navigateTo.
  const nuxtApp = useNuxtApp();
  const [audience, institutionGuideEnabled] = await Promise.all([iaAudience(), serverFlagAnswer('institution-guide-enabled')]);
  if (audience === IaAudience.Off && !institutionGuideEnabled) {
    return nuxtApp.runWithContext(() => navigateTo(clusterRedirectPath('/')));
  }
});
